require "jquery-ui"
require "angular"
require "angular-bootstrap-checkbox"
require "angular-loading-bar"
require "angular-poller"
require "angular-sanitize"
require "angular-scroll"
require "angular-ui-sortable"
require "angular-ui-tinymce"
require "angular-cookies"
require "angulartics"
require "angulartics.google.analytics"
require "arachnys-slider"
require "jvectormap/jvectormap"
require "jvectormap-world-mill-en"
require "read-more"

modules = [
  "ngCookies"
  "angularFileUpload"
  "angulartics"
  "angulartics.google.analytics"
  "angularUtils.directives.dirPagination"
  "cfp.loadingBar"
  "emguo.poller"
  "ngRoute"
  "ngSanitize"
  "oc.lazyLoad"
  "readMore"
  "angular-rich-text-diff"
  "ui.bootstrap"
  "ui.router"
  "ui.tinymce"
  "workflow.api"
  "workflow.settings"
  "ngclipboard"
  "ui.grid"
  "ui.grid.cellNav"
  "ui.sortable"
  "ui.checkbox"
  "ngTagsInput"
]

app = angular.module("workflow.app", modules).run(['uiSortableConfig', (uiSortableConfig) ->
  uiSortableConfig.jQueryPath = '/static/node_modules/jquery/dist/jquery.min.js'
  uiSortableConfig.jQueryUiPath = '/static/node_modules/jquery-ui/jquery-ui.js'
])

require "./dateFormats"
require "./config"
require "./init"
require "./directives"
require "./models"
require "./components"
require "./filters"
require "./services"
